import { useLocation } from 'react-router';
import { useRouterContext } from 'hooks/use-router-context';
/**
 * Current {pathname, search}, reliable on both server and client in Next.js
 * pages (react-router's useLocation isn't SSR-seeded there) and in the legacy
 * app. Matches react-router's useLocation shape so it can drop in for it.
 */
export const useCurrentLocation = () => {
    const nextRouter = useRouterContext();
    const { pathname: reactRouterPathname, search: reactRouterSearch, } = useLocation();
    if (!nextRouter) {
        return { pathname: reactRouterPathname, search: reactRouterSearch };
    }
    const [pathname, search = ''] = nextRouter.asPath.split('?');
    return { pathname, search: search ? `?${search}` : '' };
};
export const useCurrentPathname = () => useCurrentLocation().pathname;
